import "./TemplateManagement.css";

import React, { useEffect, useState } from "react";
import {
    createNewTemplate,
    getAllTemplates,
    getTemplate,
    updateTemplate,
} from "../../../../services/svt/svt-admin/template-management.service";

import IconButton from "../../IconButton/IconButton";
import Loader from "../../../common/Loader/Loader";
import ModalComponent from "../../ModalComponent/ModalComponent";
import PlusIcon from "../../../../assets/PlusIcon";
import { toast } from "react-toastify";
import useGetSasTokenForTemplateMaster from "../../../../utils/useGetSasTokenForTemplateMaster";
import validateFields from "../../../../utils/ValidationInput";
import { DataTableComponent } from "../../../common/TableComponent/DataTableComponent";
import { formatDate } from "../../../../utils/dateFormat";
import { useTranslation } from "react-i18next";

const newLevelData = [
    { fieldName: "Template Name", name: "name", fieldValue: "", type: "input" },
    {
        fieldName: "Status",
        name: "status",
        fieldValue: "",
        type: "dropdown",
        options: [
            { value: "active", label: "Active" },
            { value: "deactive", label: "De-active" },
        ],
    },
    { fieldName: "Image Upload", name: "image", fieldValue: "", type: "image" },
];

const TemplateManagement = () => {
    const { t, i18n } = useTranslation();
    const [sasToken] = useGetSasTokenForTemplateMaster();
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [levelData, setLevelData] = useState(newLevelData);
    const [tableData, setTableData] = useState([]);
    const [modalType, setModalType] = useState("");
    const [selectedRowIndex, setSelectedRowIndex] = useState("");
    const [viewSlotData, setViewSlotData] = useState("");
    const [preview, setPreview] = useState("");

    const columns = [
        { 
            name: t("templateName"), 
            field: "name", 
            selector: row => row.name || '', 
            sortable: true, 
            wrap: true 
        },
        // { 
        //     name: t("language"), 
        //     field: "language", 
        //     selector: row => row.language || '',
        //     sortable: true 
        // },
        { name: t("status"), field: 'status', selector: row => row.status, sortable: true },
        { name: t("modifiedDate"), field: "modifiedDate", selector: row => row.modifiedDate, cell: row => formatDate(row.modifiedDate), sortable: true },
        {
            name: t("image"), field: "image", selector: row => row.image, sortable: true, maxWidth: "200px", token: sasToken
            // cell: row =>
            //     row.image ? (
            //         <img
            //             src={row.image + sasToken}
            //             alt="template"
            //             className="tableImgStyle"
            //         />
            //     ) : (
            //         <span>No Image</span>
            //     ),
        },
    ];

    const getLevelData = () => ([
        { 
            fieldName: t('templateName'),
            type: 'multiInput',
            fields: [
                { label: '(En)', name: "name", fieldValue: formData.name || '' },
                { label: '(Jp)', name: "Name_JP", fieldValue: formData.Name_JP || '' },
                { label: '(Ch)', name: "Name_CH", fieldValue: formData.Name_CH || '' }
            ],
            required: true
        },
        // {
        //     fieldName: t("language"),
        //     name: "language",
        //     fieldValue: formData.language || "",
        //     type: "dropdown",
        //     options: [
        //         { value: "english", label: "English" },
        //         { value: "japanese", label: "Japanese" },
        //         { value: "chinese", label: "Simplified Chinese" }
        //     ],
        // },
        {
            fieldName: t("status"),
            name: "status",
            fieldValue: formData.status || "",
            type: "dropdown",
            options: [
                { value: "active", label: t("active") },
                { value: "deactive", label: t("deactive") },
            ],
        },
        { fieldName: t("imageUpload"), name: "image", fieldValue: formData.image || "", type: "image", required: true },
    ]);

    const [formData, setFormData] = useState({
        name: "",
        Name_JP: "",
        Name_CH: "",
        language: "",
        status: "active",
        image: "",
    });

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [i18n.language]);

    // Fetch all templates
    const fetchData = async () => {
        try {
            setLoading(true);
            const templatesResult = await getAllTemplates();
            // Get i18n from useTranslation
            const updatedData = templatesResult?.data.map((item) => {
                let displayName = item.name || '';
                if (i18n.language === 'jp') {
                    displayName = item.name_jp || item.name || '';
                } else if (i18n.language === 'ch') {
                    displayName = item.name_ch || item.name || '';
                }
                return {
                    ...item,
                    nameCh: item.name_ch || "",
                    nameJp: item.name_jp || "",
                    nameEn: item.name || "",
                    name: displayName,
                    language: item.language,
                    image: item.imageUri,
                    status: item.status === true ? "Active" : "De-Active",
                };
            });
            console.log(updatedData);
            setTableData(updatedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setFormData({
            name: "",
            Name_JP: "",
            Name_CH: "",
            language: "",
            status: "active",
            image: "",
        });
        setPreview("");
    };

    const onAddNewLevel = () => {
        setIsModalOpen(true);
        setModalType("add");
    };

    const onChangeInput = (inputData) => {
        const { name, value } = inputData;
        toast.dismiss();
        if ((name === "name" || name === "Name_JP" || name === "Name_CH") && value.length > 50) {
            toast.error(t("templateNameExceed"), { position: "top-center", theme: "dark" });
            return;
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const onChangeDate = (date, name) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: date.toLocaleDateString(),
        }));
    };

    const onChangeImage = (imageData, url, file) => {
        const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        if (!allowedTypes.includes(file.type)) {
            toast.error(t("onlyJpgPngSvgAllowed"), {
                position: "top-center",
            });
            return;
        }
        setPreview(url);
        setFormData((prevData) => ({
            ...prevData,
            image: url,
            imageFile: file,
        }));
    };

    const trimText = (text) => {
        return text?.trim()?.replace(/\s+/g, " ");
    };

    const saveData = async () => {
        setLoading(true);
        // Required fields with types (text or email)
        const requiredFields = [
            { label: t("templateName" + "(EN)"), key: "Template Name (EN)", type: "text", value: trimText(formData.name), label: t('templateName') },
            { label: t("templateName" + "(JA)"), key: "Template Name (JA)", type: "text", value: trimText(formData.Name_JP), label: t('templateName') },
            { label: t("templateName" + "(ZH)"), key: "Template Name (ZH)", type: "text", value: trimText(formData.Name_CH), label: t('templateName') },
            { label: t("imageUpload"), key: "Image Upload", type: "", value: formData.imageFile, label: t('imageUpload') },
        ];
        const isValid = validateFields(formData, requiredFields, "byValue");
        if (!isValid) {
            setLoading(false);
            return;
        }

        const payload = new FormData();
        payload.append("Name", trimText(formData.name));
        payload.append("Name_JP", trimText(formData.Name_JP));
        payload.append("Name_CH", trimText(formData.Name_CH));
        payload.append("shortCode", "NA");
        payload.append("Name", trimText(formData.name)); 
        payload.append("Image", formData.imageFile);
        payload.append("isActive", formData.status === "active" ? true : false);

        await createNewTemplate(payload).then((response) => {
            if (response === null) {
                setLoading(false);
            } else {
                fetchData();
                closeModal();
                setPreview("");
                setLoading(false);
            }
        });
    };

    const updateData = async () => {
        setLoading(true);
        // Required fields with types (text or email) // don't remove this code in HEU even it conflicts
        const requiredFields = [
            {
                label: t('templateName'),
                key: "Template Name",
                type: "text",
                value: trimText(formData.name),
                label: t('templateName')
            },
        ];
        const isValid = validateFields(formData, requiredFields, "byValue");
        if (!isValid) {
            setLoading(false);
            return;
        }
        // } else {
        //     if (trimText(formData?.shortCode).length > 4) {
        //         toast.error(
        //             t("shortCodeCannotExceed", { number: 4 }),
        //             { position: "top-center", theme: "dark" }
        //         );
        //     }
        // }

        const payload = new FormData();
        payload.append("Name", trimText(formData.name));
        payload.append("Name_JP", trimText(formData.Name_JP));
        payload.append("Name_CH", trimText(formData.Name_CH));
        if (formData.imageFile !== '') {
            payload.append("Image", formData.imageFile);
        }
        payload.append("ShortCode", trimText("NA"));
        payload.append("isActive", formData.status === "active" ? true : false);
        await updateTemplate(payload, formData.id).then((response) => {
            if (response === null) {
                setLoading(false);
            } else {
                fetchData();
                closeModal();
                setPreview("");
                setLoading(false);
            }
        });
    };
    const onEditDetails = (data, selectedIndex) => {
        setModalType("edit");
        setIsModalOpen(true);
        setSelectedRowIndex(selectedIndex);
        console.log(data, tableData);
        let { name, name_ch, name_jp, status, image, id, nameEn, nameJp, nameCh } = data;
        setPreview(image + sasToken);
        setFormData({
            name: nameEn || '', // Use existing name if name is not available
            Name_JP: nameJp || '', // Use existing name if Name_JP is not available
            Name_CH: nameCh || '', // Use existing name if Name_CH is not available
            status: status === "Active" ? "active" : "deactive",
            image: image,
            id: id,
            imageFile: "",
        });
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className={["glbOuterWrapper", "levelMgmt"].join(" ")}>
                    <>
                        {/* <div className="buttonOuterDiv">
                            <IconButton
                                text="New Template"
                                onClick={onAddNewLevel}
                                style={{
                                    backgroundColor: "#F0F0F0",
                                    color: "#454647",
                                    border: "1px solid #B3B2B4",
                                }}
                                icon={<PlusIcon />}
                            />
                        </div> */}
                        <div className="surveyHeader">
                            <h2 className="surveyTitle">{t("listOfTemplates")}</h2>
                            <IconButton
                                text={t("newTemplate")}
                                onClick={onAddNewLevel}
                                style={{
                                    backgroundColor: "#F0F0F0",
                                    color: "#454647",
                                    border: "1px solid #B3B2B4",
                                }}
                                icon={<PlusIcon />}
                            />
                        </div>
                        <hr></hr>

                        <div style={{ marginTop: "1rem" }}>
                            <DataTableComponent
                                columns={columns}
                                data={tableData}
                                onEditDetails={onEditDetails}
                                tableName="template"
                                noDataMessage={t('noDataFound')}
                                pageCount={5}
                            />
                        </div>

                        <ModalComponent
                            modalTitle={
                                modalType === "add"
                                    ? t("addNewTemplate")
                                    : t("updateTemplate")
                            }
                            isOpen={isModalOpen}
                            fieldsData={getLevelData()}
                            formData={formData}
                            modalType={modalType}
                            onClose={closeModal}
                            onChangeInput={onChangeInput}
                            onChangeDate={onChangeDate}
                            onChangeImage={onChangeImage}
                            preview={preview}
                            buttons={[
                                <button
                                    className="saveButton"
                                    onClick={
                                        modalType === "add"
                                            ? saveData
                                            : updateData
                                    }
                                >
                                    {modalType === "add" ? t("add") : t("update")}
                                </button>,
                                <button
                                    className="cancelButton"
                                    onClick={closeModal}
                                >
                                    {t("cancel")}
                                </button>,
                            ]}
                        />
                    </>
                </div>
            )}
        </>
    );
};

export default TemplateManagement;
